import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory } from 'slice/categorySlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getRequest } from 'apis/ApiInstence';
import Select from "react-select";
import indianCities from "../../commonData/indianCities.json";


const AddCategory = () => {
    const [formData, setFormData] = useState({
        serviceId: '',
        name: '',
        price: '',
        city: '',
        description: '',
        image: null,
        actualPrice: null
    });

    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.category);

    const cityOptions = indianCities.map((city) => ({
        value: city,
        label: city,
    }));

    // Fetch services
    useEffect(() => {
        const fetchServices = async () => {
            try {
                const res = await getRequest('product');
                setServices(res.data);
                setFilteredServices(res.data);
            } catch (err) {
                console.error('Error fetching services:', err);
            }
        };
        fetchServices();
    }, []);

    // Filter services
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredServices([]);
        } else {
            setFilteredServices(
                services.filter((s) =>
                    s.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
    }, [searchTerm, services]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'file' ? e.target.files[0] : value,
        }));
    };

    const handleCityChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            city: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleServiceSelect = (service) => {
        setFormData((prev) => ({
            ...prev,
            serviceId: service.id,
            name: service.name,
            price: service.price || '',
        }));
        setSearchTerm(service.name);
        setFilteredServices([]); // hide dropdown
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });

        try {
            await dispatch(addCategory(formDataToSend));
            toast.success('Category added successfully!');
            navigate('/category');
        } catch (error) {
            console.error('Error adding category:', error.message);
            toast.error('Failed to add category!');
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className=" font-weight-bold">Add Service</h4>
            </div>
            <form onSubmit={handleSubmit} className="form-style">
                <div className="row mx-4 mt-5">
                    {/* Search service */}
                    <div className="col-sm-4 mt-2 position-relative">
                        <label htmlFor="serviceSearch" className="lables">
                            Search & Select Service
                        </label>
                        <input
                            type="text"
                            id="serviceSearch"
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search service..."
                            autoComplete="off"
                        />
                        {filteredServices.length > 0 && (
                            <div
                                className="list-group position-absolute w-100"
                                style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                            >
                                {filteredServices.map((service) => (
                                    <button
                                        type="button"
                                        key={service.id}
                                        className="list-group-item list-group-item-action text-left"
                                        onClick={() => handleServiceSelect(service)}
                                    >
                                        {service.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Name */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="categoryName" className="lables">
                            Name
                        </label>
                        <input
                            type="text"
                            id="categoryName"
                            name="name"
                            value={formData.name}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Price actualPrice */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="priceInput" className="lables">
                            Price
                        </label>
                        <input
                            type="number"
                            id="priceInput"
                            name="price"
                            value={formData.price}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-sm-4 mt-2">
                        <label htmlFor="actualPriceInput" className="lables">
                            Actual Price
                        </label>
                        <input
                            type="number"
                            id="actualPriceInput"
                            name="actualPrice"
                            value={formData.actualPrice}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* City */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="cityInput" className="lables">
                            City
                        </label>
                        <Select
                            id="city"
                            name="city"
                            options={cityOptions}
                            onChange={handleCityChange}
                            value={cityOptions.find(
                                (option) => option.value === formData.city
                            )}
                            placeholder="Select or type city..."
                            isClearable
                            isSearchable
                        />
                    </div>

                    {/* Description */}
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="descInput" className="lables">
                            Description
                        </label>
                        <textarea
                            id="descInput"
                            rows={5}
                            name="description"
                            value={formData.description}
                            className="form-control"
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {/* Image */}
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="productImage" className="lables">
                            Image
                        </label>
                        <input
                            type="file"
                            id="productImage"
                            name="image"
                            className="form-control btn btn-primary"
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="mt-5 text-right mx-4">
                    <button className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Adding...' : 'Add'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddCategory;
